<template>
    <div id="container" class="sub-container">
        <div class="container_inner lifeconv_info">
            <div class="pc-visible sub_top_title">
                <h3 class="tit">생활편의 정보</h3>
                <div class="sub_txt pdl-24" style="color: rgb(251, 242, 103);" v-if="!$_WC.isMobile && selectedLfcnvncTab == 'hosPhar'">※ 방문 전 해당 의료기관의 실제 운영여부를 꼭 확인하시기 바랍니다.</div>
            </div>

            <LfcnvncTab />
            <LfcnvncHPSearch v-show="selectedLfcnvncTab == 'hosPhar' && $_WC.viewScale < 2"/>
            <LfcnvncWorkSearch v-show="selectedLfcnvncTab == 'incrude' && $_WC.viewScale < 2"/>
            <div class="realtime_map" v-show="selectedLfcnvncTab != 'incrude'">
                <!-- <div class="map_area_c m-visible"><h3>생활편의정보</h3></div> -->
                <NaverMapWrap />
                <LfcnvncMapNav />

                <LfcnvncHpMenu/>
                <LfcnvncApartMenu/>
                <LfcnvncMapCtrl />
                <LfcnvncApartMapCtrl />
            </div>
            
            <!-- 병의원 약국 -->
            <LfcnvncHpList v-show="selectedLfcnvncTab == 'hosPhar'" />

            <div class="data_area" v-show="selectedLfcnvncTab == 'apart'">
                <LfcnvncApartTab />
                <template>
                    <div class="data_population" v-show="selectedAtTab == 'chart'">
                        <h4>월별 {{this.selectedDate}} 매매 건수</h4>
                        <div class="grph_area mt-10">
                            <Chart :key="2236 + this.selectedDate" 
                                :chartKey="2236 + this.selectedDate"
                                :chartid="2236"
                                :params="'param1=' + this.selectedDate"
                                />
                        </div>
                        <!-- <a href="" class="btn_pre" style="top: 55%;">이전</a>
                        <a href="" class="btn_nxt" style="top: 55%;">다음</a> -->
                    </div>
    
                    <div class="data_population mt-20" v-show="selectedAtTab == 'chart'">
                        <h4 style="width:75%;">월별 {{this.selectedDate}} 매매 금액</h4>
                        <div class="grph_area mt-10 ">
                            <Chart :key="2237 + this.selectedDate" 
                                :chartKey="2237 + this.selectedDate"
                                :chartid="2237"
                                :params="'param1=' + this.selectedDate"
                                />
                        </div>
                    </div>
                </template>
                <template>
                    <LfcnvncApartList v-show="selectedAtTab == 'list'"/>
                </template>
            </div>

            <LfcnvncWorkList v-show="selectedLfcnvncTab == 'incrude'"/>
        </div>
    </div>
</template>

<script>

import { mapGetters } from 'vuex';
import { $_WC } from '@/confs/common.const.js';
import PulseLoader from "@/views/common/PulseLoader.vue";
import NaverMapWrap from '@/components/NaverMapWrap.vue';
import Chart from '@/libs/grip.chart.v3.vue';

import LfcnvncTab from "@/views/lfcnvnc/LfcnvncTab.vue";
import LfcnvncMapNav from "@/views/lfcnvnc/LfcnvncMapNav.vue";
import LfcnvncHpMenu from "@/views/lfcnvnc/LfcnvncHpMenu.vue";
import LfcnvncMapCtrl from "@/views/lfcnvnc/LfcnvncMapCtrl.vue";
import LfcnvncHpList from "@/views/lfcnvnc/LfcnvncHpList.vue";

import LfcnvncApartTab from "@/views/lfcnvnc/apart/LfcnvncApartTab.vue";
import LfcnvncApartMenu from "@/views/lfcnvnc/apart/LfcnvncApartMenu.vue";
import LfcnvncApartMapCtrl from "@/views/lfcnvnc/apart/LfcnvncApartMapCtrl.vue";
import LfcnvncApartList from "@/views/lfcnvnc/apart/LfcnvncApartListDong.vue";

import LfcnvncWorkList from "@/views/lfcnvnc/work/LfcnvncWorkList.vue";
import LfcnvncWorkSearch from "@/views/lfcnvnc/work/LfcnvncWorkSearch.vue";
import LfcnvncHPSearch from "@/views/lfcnvnc/LfcnvncHPSearch.vue";

export default {
    data() {
        return {
            param: '',
        }
    },
    components: {
        // 공통
        PulseLoader,
        NaverMapWrap,
        Chart,
        LfcnvncTab,
        LfcnvncMapNav,
        // 병의원 약국
        LfcnvncHpMenu,
        LfcnvncMapCtrl,
        LfcnvncHpList,
        LfcnvncHPSearch,
        // 아파트
        LfcnvncApartTab,
        LfcnvncApartMenu,
        LfcnvncApartMapCtrl,
        LfcnvncApartList,
        // 일자리
        LfcnvncWorkSearch,
        LfcnvncWorkList,
    },
    watch: {
        // selectedLfcnvncTab: {
        //     immediate: false,
        //     handler(newVal, oldVal) {
        //         if(newVal == 'hosPhar') {
        //             // 탭 선택 시 초기 설정 값(야간병의원)
        //             this.$eventBus.$emit('LfcnvncApp::loaded-data');
        //         }
        //     }
        // },
        selectedDate: {
            immediate: false,
            handler(newVal, oldVal) {
                this.param = newVal;
            }
        },
    },
    computed: {
        ...mapGetters({
            selectedLfcnvncTab: 'getSelectedLfcnvncTab',
            selectedAtTab: 'getSelectedAtTab',
            selectedDate: 'getSelectedDate',
        }),
    },
    created() {
        let lfcnvncTab = '';
        if(typeof this.$route.query['lfcnvncTab'] !== 'undefined' && this.$route.query['lfcnvncTab'].trim() !== '') {
            lfcnvncTab = this.$route.query['lfcnvncTab'];
        } else {
            lfcnvncTab = 'hosPhar';
        }
        
        this.$eventBus.$once('NaverMap::map-loaded', (map)=>{
            if(lfcnvncTab == 'incrude') {
                this.$store.dispatch("SET_SELECTED_LFCNVNC_TAB", lfcnvncTab);
            }
        });
        this.$eventBus.$on('LfcnvncApp::loaded-data',() => {
            this.$store.dispatch("SET_SELECTED_LFCNVNC_TAB", lfcnvncTab);
        });
    },
    methods: {
    },
};
</script>
